import { create } from 'zustand'
import { searchProducts } from '@/lib/api'
import type { Product } from '@/types'

interface SearchStore {
  query: string
  results: Product[]
  isLoading: boolean
  search: (query: string) => Promise<void>
  clearSearch: () => void
}

export const useSearchStore = create<SearchStore>((set) => ({
  query: '',
  results: [],
  isLoading: false,

  search: async (query: string) => {
    set({ query, isLoading: true })
    try {
      const results = await searchProducts(query)
      set({ results, isLoading: false })
    } catch {
      set({ results: [], isLoading: false })
    }
  },

  clearSearch: () => set({ query: '', results: [] }),
}))
